// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ffbr","rootNoMargin":"styles_rootNoMargin__3JHG7"};